/* Monty's — small shared behaviors. No frameworks.
   Forms: until the real endpoints exist, submitting opens a prefilled email
   in the visitor's mail app so no lead dies in a dead form.
   TODO: swap the mailto handlers for live endpoints (line sheet -> Lauren,
   drop list + newsletter -> email platform) and confirm the real addresses. */
(function () {
  'use strict';

  /* ---- SHOP TOGGLE ----
     Flip this single flag to turn the limited-drop shop on/off site-wide.
     true  = "Shop" appears in the menus and /shop is reachable
     false = links hidden and /shop bounces to the homepage */
  var SHOP_ENABLED = true;

  if (SHOP_ENABLED) {
    document.documentElement.classList.add('shop-on');
  } else if (document.body && document.body.dataset.page === 'shop') {
    window.location.replace('/');
  }

  var SALES = 'lauren@montysnyc.com';
  var HELLO = 'hello@livemontys.com';

  /* ---- mobile menu: keyboard + escape + aria ---- */
  var burger = document.querySelector('.nav-burger');
  var toggle = document.getElementById('navtoggle');
  if (burger && toggle) {
    burger.setAttribute('role', 'button');
    burger.setAttribute('tabindex', '0');
    burger.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('change', function () {
      burger.setAttribute('aria-expanded', String(toggle.checked));
    });
    burger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle.checked = !toggle.checked;
        toggle.dispatchEvent(new Event('change'));
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.checked) {
        toggle.checked = false;
        toggle.dispatchEvent(new Event('change'));
      }
    });
  }

  function mailto(to, subject, body) {
    window.location.href = 'mailto:' + to +
      '?subject=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(body);
  }

  /* ---- gated forms: mailto fallback ONLY for forms without a live endpoint.
     Forms with a real action (e.g. the retail line sheet -> FormSubmit -> Lauren)
     submit natively and are skipped here. ---- */
  document.querySelectorAll('form.gate').forEach(function (form) {
    var action = form.getAttribute('action');
    if (action && action !== '#') return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = form.querySelector('[name="name"]');
      var company = form.querySelector('[name="company"]');
      var email = form.querySelector('[name="email"]');
      if (company) {
        mailto(SALES, 'Line sheet request — ' + company.value,
          'Name: ' + name.value +
          '\nCompany: ' + company.value +
          '\nWork email: ' + email.value +
          '\n\nPlease send the Monty’s line sheet.');
      } else {
        mailto(HELLO, 'Add me to the drop list',
          'Please add ' + email.value + ' to the Monty’s drop list.');
      }
      var note = form.querySelector('.fineprint');
      if (note) note.textContent = 'Opening your email app — hit send on the drafted email and we’ll take it from there.';
    });
  });

  /* ---- footer newsletter ---- */
  document.querySelectorAll('.news .field').forEach(function (field) {
    var input = field.querySelector('input');
    var button = field.querySelector('button');
    if (!input || !button) return;
    button.addEventListener('click', function () {
      if (!input.value || !input.checkValidity()) { input.focus(); return; }
      mailto(HELLO, 'Newsletter signup',
        'Please add ' + input.value + ' to the Monty’s newsletter.');
    });
  });
})();
